import React from 'react';


export function ProcessFlow({ currentStep, setStep }){
  const steps = [
    { id: 1, label: 'Plan' },
    { id: 2, label: 'Generate' },
    { id: 3, label: 'Deploy' },
    { id: 4, label: 'Measure' },
    { id: 5, label: 'Optimize' },
  ];

  const descriptions = {
    1: { title: "1. Plan", desc: "Ingest the Brand Book and define campaign strategy. The Agent analyzes 'Do's and Don'ts' and aligns them with your current marketing goals." },
    2: { title: "2. Generate", desc: "The Agent produces a cohesive suite of assets instantly: Digital Signage visuals, TTS Audio announcements, and Kinetic Typography videos." },
    3: { title: "3. Deploy", desc: "Approved assets are pushed directly to the Store CMS. Signage updates on screen, audio playlists refresh, and electronic shelf labels reflect new messaging." },
    4: { title: "4. Measure", desc: "Real-time analytics track performance. System monitors QR code scans, foot traffic heatmaps, and sales lift during the campaign window." },
    5: { title: "5. Optimize", desc: "The AI Loop closes. Performance data feeds back into the system to refine future content generation, suggesting better times, voices, or visuals." },
  };

  return (
    <section id="core-flow" className="py-16 bg-white border-y border-blue-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 text-center">
          <h2 className="text-3xl font-bold text-blue-900">Five Step Process</h2>
          <p className="mt-4 text-blue-600 max-w-2xl mx-auto">
            A continuous cycle of intelligent marketing automation. Click a step to explore.
          </p>
        </div>

        {/* Stepper */}
        <div className="relative mb-12">
           <div className="flex flex-col md:flex-row justify-between items-center gap-4 relative z-10">
              {steps.map((step, idx) => (
                <React.Fragment key={step.id}>
                  <button 
                    onClick={() => setStep(step.id)}
                    className="group flex flex-col items-center focus:outline-none w-full md:w-auto"
                  >
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold text-lg shadow-lg transition-all duration-300 ${
                      currentStep === step.id 
                        ? 'bg-blue-600 text-white scale-110' 
                        : 'bg-blue-50 text-blue-400 hover:bg-blue-100'
                    }`}>
                      {step.id}
                    </div>
                    <span className={`mt-2 font-semibold text-sm transition-colors ${
                      currentStep === step.id ? 'text-blue-900' : 'text-blue-400'
                    }`}>
                      {step.label}
                    </span>
                  </button>
                  {idx < steps.length - 1 && (
                    <div className="hidden md:block h-1 flex-1 bg-blue-100 rounded-full mx-4"></div>
                  )}
                </React.Fragment>
              ))}
           </div>
        </div>

        {/* Dynamic Description Box */}
        <div className="bg-white rounded-xl shadow-md p-8 border border-blue-200 min-h-[150px] flex items-center justify-center transition-all duration-300">
           <div key={currentStep} className="text-center max-w-3xl animate-fade-in">
              <h3 className="text-xl font-bold text-blue-900 mb-2">{descriptions[currentStep].title}</h3>
              <p className="text-blue-700 leading-relaxed">{descriptions[currentStep].desc}</p>
           </div>
        </div>
      </div>
    </section>
  );
};